<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <path
      d="M10 2.5C7.23858 2.5 5 4.73858 5 7.5V11.5L3 14.5H17L15 11.5V7.5C15 4.73858 12.7614 2.5 10 2.5Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path
      d="M8 17.5C8.5 18.1 9.2 18.5 10 18.5C10.8 18.5 11.5 18.1 12 17.5"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
    />
  </svg>
</template>
